import { FetchError } from "../errors/FetchError";
import { fetchWithAuthorization } from "./fetch";

// HO-HU-36: estado de la guia de primeros pasos de un condominio. El backend
// resuelve los seis pasos en un solo request (ver OnboardingController) en vez
// de que el Inicio tenga que preguntarle a cada modulo por separado.

export const fetchOnboardingStatus = async (condominiumId) => {
  try {
    const { data } = await fetchWithAuthorization(
      `/condominium/onboarding/${condominiumId}`
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Error fetching onboarding status");
  }
};

/**
 * Marca (o desmarca) a mano un paso: es lo que hacen los botones
 * "Ya lo hice" / "No aplica" de los pasos que no dejan un rastro
 * consultable en los datos.
 */
export const setOnboardingStepDismissed = async (
  condominiumId,
  step,
  dismissed = true
) => {
  try {
    const { data } = await fetchWithAuthorization(
      `/condominium/onboarding/${condominiumId}`,
      { step, dismissed },
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Error updating onboarding step");
  }
};

/**
 * Oculta o vuelve a mostrar la guia entera para este condominio. No marca
 * ningun paso: es una preferencia sobre la guia.
 */
export const setOnboardingHidden = async (condominiumId, hidden) => {
  try {
    const { data } = await fetchWithAuthorization(
      `/condominium/onboarding/${condominiumId}/visibility`,
      { hidden },
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Error updating onboarding visibility");
  }
};
